var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",staticClass:"iframe-container",attrs:{"src":"http://localhost:5173/"}})}
var staticRenderFns = []

export { render, staticRenderFns }